var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon d-flex justify-content-center align-items-center",class:{ 'small': _vm.small }},[_c('i',{staticClass:"far",class:_vm.icon,style:({'color': (_vm.theme === 'dark') ? 'inherit' : 'white'})})])}
var staticRenderFns = []

export { render, staticRenderFns }